const zendeskRemoteLoginUrl = import.meta.env.VITE_ZENDESK_REMOTE_LOGIN_URL;
const zendeskRemoteLogoutUrl = import.meta.env.VITE_ZENDESK_REMOTE_LOGOUT_URL;
const zendeskEnvironmentUrl = import.meta.env.VITE_ZENDESK_ENVIRONMENT_URL;

export { zendeskRemoteLoginUrl, zendeskRemoteLogoutUrl, zendeskEnvironmentUrl };
